import React, { useState } from "react";
import { Download, File, Trash2 } from "lucide-react";
import dayjs from "dayjs";
import { toast } from "react-toastify";

import { serverUrl } from "services/api";

import { DeleteDocumentModal } from "../DeleteDocumentModal";

import {
	DocumentCardContainer,
	DocumentCardContentContainer,
	DocumentCardFileNumberContainer,
	DocumentCardLeftContentContainer,
	DocumentCardRightContentContainer,
	DocumentCardIconContainer
} from "./styles";

export function DocumentCard({ document, token, onDocumentDeleted }) {
	const [isModalOpen, setIsModalOpen] = useState(false);

	function formatDate(dateString) {
		const date = dayjs(dateString);
		const today = dayjs();
		const yesterday = today.subtract(1, "day");

		if (date.isSame(today, "day")) {
			return `Hoje - ${date.format("HH:mm")}`;
		} else if (date.isSame(yesterday, "day")) {
			return `Ontem - ${date.format("HH:mm")}`;
		} else {
			return `${date.format("DD/MM")} - ${date.format("HH:mm")}`;
		}
	}

	async function handleDownloadDocument() {
		try {
			const response = await fetch(
				`${serverUrl}/contract-solicitation-document/${document._id}/download`,
				{ headers: { Authorization: "Bearer " + token } }
			);

			if (!response.ok) throw new Error("Download failed");

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);
			const link = window.document.createElement("a");
			link.href = url;
			link.download = document.documentName || `documento_${document._id}.pdf`;
			window.document.body.appendChild(link);
			link.click();
			window.document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			toast.error("Erro ao fazer download do documento.");
			console.error("Erro ao fazer download do documento:", error);
		}
	}

	function handleDeleteDocument() {
		setIsModalOpen(true);
	}

	function handleDocumentDeleted() {
		onDocumentDeleted && onDocumentDeleted();
	}

	return (
		<DocumentCardContainer>
			<DocumentCardLeftContentContainer>
				<DocumentCardIconContainer>
					<File size={20} color="#31475a" strokeWidth={2} />
				</DocumentCardIconContainer>
				<DocumentCardContentContainer>
					<DocumentCardFileNumberContainer>
						<p>Documento</p>
						<p>{formatDate(document.createdAt)}</p>
					</DocumentCardFileNumberContainer>

					<p>{document.documentName}</p>
				</DocumentCardContentContainer>
			</DocumentCardLeftContentContainer>

			<DocumentCardRightContentContainer>
				<button onClick={handleDownloadDocument}>
					<Download size={20} color="#31475a" strokeWidth={2} />
				</button>
				<button onClick={handleDeleteDocument}>
					<Trash2 size={20} color="#31475a" strokeWidth={2} />
				</button>

				<DeleteDocumentModal
					isModalOpen={isModalOpen}
					setIsModalOpen={setIsModalOpen}
					documentId={document._id}
					documentName={document.documentName}
					onDocumentDeleted={handleDocumentDeleted}
				/>
			</DocumentCardRightContentContainer>
		</DocumentCardContainer>
	);
}
